<template>
  <div>
    <div class="uk-section">
      <div class="uk-container uk-container-small">
      <div>
      <h2>Events</h2>
        <ul class="uk-list uk-list-divider">
          <li v-for="event in tournaments" :key="event.slug">
            <router-link
            :to="{ path: 'event/' + event.slug }"
            :key="event.slug"
            >
              {{ event.name }} ({{ moment(event.startdate).format("DD.MM.YYYY") }} - {{ moment(event.enddate).format("DD.MM.YYYY") }})
            </router-link>
          </li>
        </ul>
      </div>
      </div>
    </div>        
</div>
</template>

<script>
var moment = require("moment");
import gql from "graphql-tag";

export default {
  data() {
    return {
      tournaments: {},
      moment: moment,
      api_url: process.env.VUE_APP_STRAPI_API_URL,
      routeParam: this.$route.params.id
    };
  },
  name: "Events",
  apollo: {
    tournaments: {
      query: gql`
        query Tournaments {
          tournaments(where: { type: "event" }) {
            id,
            name,
            logo {
              url
            },
            url,
            slug,
            startdate,
            enddate
            }
        }
      `,
      pollInterval: 10000, // ask for updated info every 10 seconds
      variables() {
          console.log('Test:' + this.query)
        return {
          period: this.routeParam
        };
      }
    }
  }
};
</script>